"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.longDateFormatWithTime = exports.monthDayYearUtc = exports.monthDayYear = exports.longDateFormat = exports.longDateTimeFormatWithTimeZone = exports.shortDateTimeFormatWithTimeZone = exports.shortDateFormat = exports.standardUTCDateFormat = exports.standardDateFormat = void 0;
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
function standardDateFormat(date) {
    return date_fns_1.format(new Date(date), 'MM/dd/yyyy');
}
exports.standardDateFormat = standardDateFormat;
function standardUTCDateFormat(date) {
    var utcDate = date_fns_tz_1.utcToZonedTime(new Date(date), 'UTC');
    return date_fns_1.format(utcDate, 'MM/dd/yyyy');
}
exports.standardUTCDateFormat = standardUTCDateFormat;
function shortDateFormat(date) {
    return date_fns_1.format(new Date(date), 'ddd M/D');
}
exports.shortDateFormat = shortDateFormat;
/**
 * 10/9 9:12AM PDT
 */
function shortDateTimeFormatWithTimeZone(date) {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var zonedDate = date_fns_tz_1.utcToZonedTime(new Date(date), timeZone);
    return date_fns_tz_1.format(zonedDate, 'M/d h:mm a z', { timeZone: timeZone });
}
exports.shortDateTimeFormatWithTimeZone = shortDateTimeFormatWithTimeZone;
/**
 * 10/9/2020 9:12AM PDT
 */
function longDateTimeFormatWithTimeZone(date) {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var zonedDate = date_fns_tz_1.utcToZonedTime(new Date(date), timeZone);
    return date_fns_tz_1.format(zonedDate, 'M/d/yyyy h:mm a z', { timeZone: timeZone });
}
exports.longDateTimeFormatWithTimeZone = longDateTimeFormatWithTimeZone;
/**
 * Tuesday Jun 16, 2020 11:29 PM
 */
function longDateFormat(date) {
    return date_fns_1.format(new Date(date), 'EEEE MMM dd, yyyy h:mm a');
}
exports.longDateFormat = longDateFormat;
/**
 * Example: June 28th 1971
 */
function monthDayYear(date) {
    return date ? date_fns_1.format(new Date(date), 'MMMM do yyyy') : '';
}
exports.monthDayYear = monthDayYear;
function monthDayYearUtc(date) {
    var d = new Date(date);
    var utcDate = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    return date_fns_1.format(utcDate, 'MMMM do yyyy');
}
exports.monthDayYearUtc = monthDayYearUtc;
/**
 * Example: 2020/08/12 04:25 PM
 */
function longDateFormatWithTime(date) {
    return date_fns_1.format(new Date(date), 'YYYY/MM/DD hh:mm A');
}
exports.longDateFormatWithTime = longDateFormatWithTime;
